import { Calendar, CalendarCheck, Clock } from 'lucide-react';
import { SubHubLayout } from './SubHubLayout';

/**
 * `/admin/parametros/prazos` — ONDA-CA2, item ADM-054 do laudo de comparação QA.
 *
 * Os três destinos nasceram inertes, com selo "Em construção", porque nenhuma
 * das telas existia. Os três passaram a existir e ganharam link:
 *
 * - Prazos do sistema e Dias letivos foram construídos na ONDA-T3;
 * - Ciclos de inscrição JÁ EXISTIA, ligada à API de verdade
 *   (`apps/api/src/modulos/ciclo-inscricao/`), só vivia em
 *   `/admin/chamamentos`, fora do padrão de rota deste hub — renomeada para
 *   `/admin/parametros/ciclos-inscricao`, mesmo padrão dos outros dois itens.
 */
export function PrazosCalendarioHub() {
  return (
    <SubHubLayout
      titulo="Prazos & calendário"
      descricao="SLAs, alertas de vencimento, dias letivos e ciclos de inscrição — parametrizável sem deploy."
      voltarPara="/admin"
      itens={[
        {
          titulo: 'Prazos do sistema',
          descricao: 'SLAs de aprovação, alertas de vencimento e bloqueios.',
          icone: Clock,
          para: '/admin/parametros/prazos/sistema',
        },
        {
          titulo: 'Dias letivos',
          descricao: 'Calendário escolar oficial, por DRE e mês.',
          icone: Calendar,
          para: '/admin/parametros/dias-letivos',
        },
        {
          titulo: 'Ciclos de inscrição',
          descricao: 'Janelas de inscrição com prazo configurável.',
          icone: CalendarCheck,
          para: '/admin/parametros/ciclos-inscricao',
        },
      ]}
    />
  );
}

export default PrazosCalendarioHub;
